import { render, staticRenderFns } from "./147.vue?vue&type=template&id=37f1899f&scoped=true&"
import script from "./147.vue?vue&type=script&lang=js&"
export * from "./147.vue?vue&type=script&lang=js&"
import style0 from "./147.vue?vue&type=style&index=0&id=37f1899f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1899f",
  null
  
)

export default component.exports